import PanoramicDefaultViewButton from './PanoramicDefaultViewButton';

export default PanoramicDefaultViewButton;
